import {
    getUserGroup,
    getUserGroupForDelete,
    putActiveAll,
    putActiveAllGroup,
    postMoveUserToNewGroup,
    moveUserToBin,
    deleteUserAllGroup
} from "@/service/account/manageUser";
export default {
    computed: {
        selectedGroups() {
            return this.$vuetify.lang.t(
                "$vuetify.learnerManagement.learnerList.selectedGroups"
            );
        },

        headers() {
            return [
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.learnerList.name"
                    ),
                    value: "fullName",
                    align: "start",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.learnerList.email"
                    ),
                    value: "email",
                    align: "start",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.learnerList.username"
                    ),
                    value: "username",
                    align: "start",
                    sortable: false,
                },

                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.learnerList.status"
                    ),
                    value: "active",
                    align: "start",
                    sortable: false,
                },
            ];
        },
    },
    data: function () {
        return {
            params: {},
            arrayGroup: [],
            userGroupSearch: [],
            selectedGroupsForMove: [],
            users: [],
            loading: false,
            confirm_dialog: false,
            confirm_dialog_status: false,
            imageReady: false,
            dialogStatus: false,
            dialogStatusActive: false,
            dialogMoveGroup: false,
            dataStatus1: [],
            dataStatus2: [],
            page_student_manage: 1,
            pageCount_student_manage: 1,

        };
    },
    props: {
        isOpen: {
            type: Boolean,
        },
        closeDeleteUser: {
            type: Function,
        },
    },
    watch: {
        isOpen: async function (newValue) {
            if (newValue) {
                this.params = {
                    search: null,
                    sort: "created_at",
                    sortby: -1,
                    usergroup: null,
                    page: 1,
                    limit: 10,
                    active: "null",
                };
                console.log(newValue);
                this.getUserGroupList();
                // await getUserGroup()
            }
        },
    },

    methods: {
        closeDeleteDialog() {
            this.userGroupSearch = [];
            this.users = [];
            this.selectedGroupsForMove = [];
            this.closeDeleteUser();
            this.page_student_manage = 1;
            this.pageCount_student_manage = 1;
        },
        async getUserGroupList() {
            let result = await getUserGroup(this.params);
            this.groupUsers = [];
            // let userGroupAllAtIndex=[]
            this.arrayGroup = [];
            this.arrayGroup.push({
                title: 'ไม่มีกลุ่ม',
                _id: ''
            });
            await result.forEach(async (group) => {
                // let arrayGroup = []
                group.child_User_Group.length === 0
                    ? await this.arrayGroup.push({
                        title: group.title,
                        _id: group._id,
                    })
                    : null;
                group.child_User_Group.forEach(async (child) => {
                    child.child_User_Group.length === 0
                        ? await this.arrayGroup.push({
                            title: group.title + " -> " + child.title,
                            _id: child._id,
                        })
                        : null;
                    child.child_User_Group.forEach(async (lastChild) => {
                        await this.arrayGroup.push({
                            title:
                                group.title + " -> " + child.title + " -> " + lastChild.title,
                            _id: lastChild._id,
                        });
                    });
                });
                // await userGroupAllAtIndex.push({arrayGroup})
            });
            console.log(this.arrayGroup);
            this.groupUsers = result;
            // this.filterGroupResult = result;
        },
        async applyFilter() {
            this.params.usergroup = [];
            this.params.sort = null;
            this.params.sortby = null;
            if (this.status_toggle == 1) {
                this.params.active = true;
                this.params.page = this.page;
                this.params.usergroup = await this.userGroupSearch;
                // console.log(this.params.usergroup)
                if (this.userGroupSearch.length != 0) {
                    await this.getUserList();
                } else {
                    this.users = [];
                }
                console.log("if");
            } else if (this.status_toggle == 2) {
                this.params.active = false;
                this.params.page = this.page;
                this.params.usergroup = await this.userGroupSearch;

                if (this.userGroupSearch.length != 0) {
                    await this.getUserList();
                } else {
                    this.users = [];
                }
                console.log("else if");
            } else {
                this.params.groupnull = false;
                this.params.active = "null";
                this.params.page = this.page;
                this.params.usergroupOld = [];
                // console.log("1234567894");
                // console.log(this.userGroupSearch);
                if (this.userGroupSearch.length != 0) {
                    this.userGroupSearch.forEach(usr => {
                        if (usr._id != "") {
                            this.params.usergroupOld.push(usr);
                            this.params.usergroup.push(usr._id)
                        } else {
                            this.params.groupnull = true;
                        }
                    });
                    await this.getUserList();
                } else {
                    this.users = [];
                }

                console.log("else");
            }
        },
        async getUserList() {
            this.loading = true;
            this.dataStatus1 = [];
            this.dataStatus2 = [];
            // localStorage.removeItem("editCourseID");
            // console.log(this.params);
            let result = await getUserGroupForDelete(this.params);
            this.users = [];
            this.pageCount_student_manage = Math.ceil(result.data.length / this.limit);
            this.pageCount_student_manage = result.maxPage;
            //   this.imageReady = false;
            await result.data.forEach(async (user) => {
                this.users.push({
                    id: user._id,
                    //   image: user.image,
                    fullName: user.firstName + " " + user.lastName,
                    email: user.email,
                    username: user.username,
                    active: user.active,
                    // group: user.user_groups
                });
                if (user.active == false) {
                    this.dataStatus1.push({
                        id: user._id,
                    });
                } else {
                    this.dataStatus2.push({
                        id: user._id,
                    });
                }
            });
            // console.log("list user : ", this.users);
            //   this.imageReady = true;
            this.loading = false;
        },
        async showGroupList(userGroup) {
            let userGroupOutput = [];
            await userGroup.forEach(
                async (grouplist) =>
                    await this.arrayGroup.forEach(async (group) =>
                        group._id == grouplist._id
                            ? await userGroupOutput.push(group)
                            : null
                    )
            );
            return userGroupOutput;
        },
        async confirmDelete() {
            console.log("this.users", this.users);
            let data = [];
            await this.users.forEach(async (user) =>
                data.push({
                    id: user.id,
                })
            );
            console.log("data", data);
            let arrayIdUserGroup = [];
            for (let i in this.userGroupSearch) {
                this.loadingDelete = true;
                arrayIdUserGroup.push(
                    this.userGroupSearch[i]._id,
                );
            }
            let deleteData = {
                active: false,
                usergroup: arrayIdUserGroup
            }
            let result = await putActiveAllGroup(deleteData);
            // let result_moveUserToBin = await moveUserToBin({
            //     arraystudent: data,
            //     istrash: true,
            // });
            let result_moveUserToBin = await deleteUserAllGroup({
                usergroup: arrayIdUserGroup,
                istrash: true,
            })
            console.log("result", result, result_moveUserToBin);
            this.closeDeleteDialog();
        },

        async confirmStatus(type) {
            console.log("this.users", this.users);
            let data1 = [];
            let data2 = [];
            let arrayIdUserGroup = [];
            for (let i in this.userGroupSearch) {
                this.loadingDelete = true;
                arrayIdUserGroup.push(
                    this.userGroupSearch[i]._id,
                );
            }
            await this.users.forEach(async (user) => {
                if (user.active == true) {
                    data1.push({
                        id: user.id,
                    });
                } else {
                    data2.push({
                        id: user.id,
                    });
                }
            });
            console.log("data", data1, data2);
            if (type == "off") {
                let result = await putActiveAllGroup({
                    usergroup: arrayIdUserGroup,
                    active: false,
                });
                console.log("result", result);
            } else {
                let result = await putActiveAllGroup({
                    usergroup: arrayIdUserGroup,
                    active: true,
                });
                console.log("result", result);
            }

            //   let result_moveUserToBin = await moveUserToBin({
            //     arraystudent: data,
            //     istrash: true,
            //   });

            this.closeDeleteDialog();
        },
        async moveGroupfn() {
            console.log("moveGroupfn");
            let dataStudent = [];
            await this.users.forEach(async (user) =>
                dataStudent.push({
                    student: user.id,
                })
            );
            let arrayUserGroup = await this.selectedGroupsForMove;
            // let data = {
            //     user_groups: arrayUserGroup,
            //     array_student: dataStudent
            // }
            let arrayIdUserGroup = [];
            for (let i in this.userGroupSearch) {
                this.loadingDelete = true;
                arrayIdUserGroup.push(
                    this.userGroupSearch[i]._id,
                );
            }
            let data = {
                usergroupnew: arrayUserGroup,
                usergroupold: arrayIdUserGroup
            }
            console.log("data", data);
            let result = await postMoveUserToNewGroup(data);

            console.log("result", result);
            this.closeDeleteDialog();

        },
        async closeMoveGroup() {
            this.selectedGroupsForMove = [];
            this.dialogMoveGroup = false
        },
        // async moveGroupAt() {
        //     this.params.selectedGroupsForMove = [];
        //     this.params.selectedGroupsForMove = await this.selectedGroupsForMove;
        //     if (this.selectedGroupsForMove.length != 0) {
        //         // await this.getUserList();
        //     } else {
        //         this.params.selectedGroupsForMove = [];
        //     }
        //     console.log(this.params.selectedGroupsForMove)

        // },

        async changePageStudent(page) {
            this.params.page = page;
            this.users = [];
            await this.getUserList()
        },
    },
}
